export default __webpack_public_path__ + "assets/56cb0ad613fa9fb2a9010b7dcc6602a2.png";